export default "__VITE_ASSET__DBe5Aq3y__"